/* GRIYGO: recomendamos e adicionamos itens sem sair do carrinho lateral. */
if (!customElements.get('griygo-cart-upsell')) {
  customElements.define('griygo-cart-upsell', class GriygoCartUpsell extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', (event) => this.onClick(event));
      this.addEventListener('change', (event) => this.onVariantChange(event));
    }

    connectedCallback() {
      this.querySelector('.griygo-upsell__track')?.addEventListener('scroll', () => this.updateArrows(), {passive: true});
      this.updateArrows();
    }

    onVariantChange(event) {
      const select = event.target.closest('.griygo-upsell__variant');
      if (!select) return;
      const card = select.closest('.griygo-upsell__card');
      const option = select.selectedOptions[0];
      card.querySelector('.griygo-upsell__add').dataset.variantId = select.value;
      card.querySelector('.griygo-upsell__price').textContent = option.dataset.price;
      const compare = card.querySelector('.griygo-upsell__compare');
      if (compare) {
        compare.textContent = option.dataset.compare || '';
        compare.hidden = option.dataset.hasCompare !== 'true';
      }
    }

    onClick(event) {
      const arrow = event.target.closest('.griygo-upsell__prev, .griygo-upsell__next');
      if (arrow) {
        const track = this.querySelector('.griygo-upsell__track');
        const card = track.querySelector('.griygo-upsell__card');
        if (!card) return;
        const width = card.getBoundingClientRect().width + 9;
        track.scrollBy({ left: arrow.classList.contains('griygo-upsell__next') ? width : -width, behavior: 'smooth' });
        setTimeout(() => this.updateArrows(), 350);
        return;
      }
      const button = event.target.closest('.griygo-upsell__add');
      if (button) this.addToCart(button);
    }

    updateArrows() {
      const track = this.querySelector('.griygo-upsell__track');
      if (!track) return;
      const prev = this.querySelector('.griygo-upsell__prev');
      const next = this.querySelector('.griygo-upsell__next');
      if (prev) prev.disabled = track.scrollLeft < 4;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    }

    async addToCart(button) {
      if (button.disabled) return;
      const drawer = this.closest('cart-drawer');
      const status = this.querySelector('.griygo-upsell__message');
      const variantId = Number(button.dataset.variantId);
      if (!Number.isSafeInteger(variantId)) return;
      button.disabled = true;
      button.querySelector('span').textContent = 'Adicionando...';
      status.textContent = '';
      try {
        const response = await fetch(window.routes?.cart_add_url || `${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: {'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
          body: JSON.stringify({
            items: [{id: variantId, quantity: 1}],
            sections: ['cart-drawer','cart-icon-bubble'],
            sections_url: window.location.pathname
          })
        });
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || data.message || 'Não foi possível adicionar este item.');
        // O Dawn substitui a seção real do carrinho e atualiza o ícone com o contador.
        if (drawer && data.sections && data.sections['cart-drawer']) {
          drawer.setActiveElement(button);
          drawer.renderContents(data);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'griygo-cart-upsell', productVariantId: variantId, cartData: data });
          }
        } else {
          window.location.assign(window.routes?.cart_url || '/cart');
        }
      } catch (error) {
        status.textContent = error.message || 'Não foi possível adicionar. Tente novamente.';
        button.disabled = false;
        button.querySelector('span').textContent = '+ Adicionar';
      }
    }
  });
}
